export default {
  policyEffectiveDate: 'Policy Effective Date',
  policyEffectiveDateRequired: 'Policy Effective Date is required',
  yearsOfExperience: 'Years Of Experience',
  yearsOfExperienceRequired: 'Years Of Experience is required',
  regionOfPractice: 'Region Of Practice',
  regionOfPracticeRequired: 'Region Of Practice is required',
  placeOfPractice: 'Place Of Practice',
  placeOfPracticeRequired: 'Place Of Practice is required',
  specialty: 'Specialty',
  specialtyRequired: 'Specialty is required',
  isPerformingSurgeries: 'Are you performing surgeries?',
  isPerformingSurgeriesRequired:
    'Please specify if you are performing surgeries',
  continue: 'Continue',
  previous: 'Previous',
  MMP_PlaceOfPracticeRequiredMsg:
    'Please select place(s) of practice, insurance companies may ask about these places names in further steps',
  missingSubSpecialty: 'Other Subspecialty',
  missingSubSpecialtyRequired: 'Other Subspecialty is required',
  noSpecialtiesFound: 'No specialties found',
  selectSpecialty: 'Select specialty',
} as const
